module.exports = __webpack_public_path__ + "img/phone.e0b9a4e9.svg";